declare global {
  interface Window {
    FlipFlop: FlipFlop;
  }
}

type FlipFlop = {
  parentChild: boolean;
  interviewEndTimes: boolean;
  emailDomainManagement: boolean;
  companyLocationManagement: boolean;
  companySocialsManagement: boolean;
  employerSettingsSliceTwo: boolean;
  currencyFlagInNavbar: boolean;
  displayPartnerEngagementsInYourJobs: boolean;
  manageTeamMembers: boolean;
  demoEnvironment: boolean;
};

export const isFeatureEnabled = (name: keyof FlipFlop) =>
  Boolean(window.FlipFlop?.[name]);

export const fileToBase64 = (file: File | Blob) =>
  new Promise<string | ArrayBuffer>((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.readAsDataURL(file);
  });

/**
 * Checks if the given url already has a protocol, otherwise adds https:// to
 * start of the given string.
 *
 * @param url The string to prefix.
 */
export const addHttpsPrefix = (url: string) => {
  if (url.startsWith("https://") || url.startsWith("http://")) {
    return url;
  }

  return `https://${url}`;
};

export const arrayify = (val: unknown) => {
  if (Array.isArray(val)) {
    return val;
  }

  return [val];
};
